document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".project-library").forEach((library) => {

    const filterType = library.dataset.filterType;
    const postsPerPage = parseInt(
      library.dataset.postsPerPage,
      10
    ) || 12;

    const tabsContainer = library.querySelector(
      "[data-project-tabs]"
    );

    const grid = library.querySelector(
      "[data-project-grid]"
    );

    const cards = Array.from(
      library.querySelectorAll(".project-card")
    );


    /*
      ==========================================
      Basic validation
      ==========================================
    */

    if (!tabsContainer || !grid || !cards.length) {
      return;
    }


    /*
      ==========================================
      Pagination container
      ==========================================
    */

    let pagination = library.querySelector(
      "[data-project-pagination]"
    );

    if (!pagination) {

      pagination = document.createElement("nav");

      pagination.className =
        "project-library__pagination";

      pagination.setAttribute(
        "data-project-pagination",
        ""
      );

      pagination.setAttribute(
        "aria-label",
        "Project pagination"
      );

      grid.insertAdjacentElement(
        "afterend",
        pagination
      );
    }


    /*
      ==========================================
      Get filter values
      ==========================================
    */

    const filterValues = new Set();

    cards.forEach((card) => {

      const value = card.dataset[filterType];

      if (value && value.trim() !== "") {

        filterValues.add(
          value.trim()
        );

      }

    });


    /*
      ==========================================
      Create All Projects button
      ==========================================
    */

    const allButton =
      document.createElement("button");

    allButton.type = "button";

    allButton.className =
      "project-tab active";

    allButton.dataset.filter =
      "all";

    allButton.textContent =
      "All Projects";

    allButton.setAttribute(
      "role",
      "tab"
    );

    allButton.setAttribute(
      "aria-selected",
      "true"
    );

    tabsContainer.appendChild(
      allButton
    );


    /*
      ==========================================
      Convert values into readable labels
      ==========================================
    */

    function formatLabel(value) {

      if (!value) {
        return "";
      }

      const countryLabels = {
        usa: "USA",
        uk: "UK",
        uae: "UAE"
      };

      if (countryLabels[value]) {
        return countryLabels[value];
      }

      let label = value
        .replace(/[-_]+/g, " ")
        .trim();

      label = label.replace(
        /\b\w/g,
        (letter) => letter.toUpperCase()
      );

      return label;
    }


    /*
      ==========================================
      Create category buttons
      ==========================================
    */

    Array.from(filterValues).forEach(
      (value) => {

        const button =
          document.createElement("button");

        button.type = "button";

        button.className =
          "project-tab";

        button.dataset.filter =
          value;

        button.textContent =
          formatLabel(value);

        button.setAttribute(
          "role",
          "tab"
        );

        button.setAttribute(
          "aria-selected",
          "false"
        );

        tabsContainer.appendChild(
          button
        );

      }
    );


    /*
      ==========================================
      Get all tabs
      ==========================================
    */

    const tabs =
      tabsContainer.querySelectorAll(
        ".project-tab"
      );


    /*
      ==========================================
      Current state
      ==========================================
    */

    let currentFilter = "all";

    let currentPage = 1;


    /*
      ==========================================
      Set active tab
      ==========================================
    */

    function setActiveTab(activeTab) {

      tabs.forEach((tab) => {

        tab.classList.remove(
          "active"
        );

        tab.setAttribute(
          "aria-selected",
          "false"
        );

      });

      activeTab.classList.add(
        "active"
      );

      activeTab.setAttribute(
        "aria-selected",
        "true"
      );

    }


    /*
      ==========================================
      Get filtered cards
      ==========================================
    */

    function getFilteredCards(value) {

      if (value === "all") {
        return cards;
      }

      return cards.filter((card) => {

        const currentValue =
          card.dataset[filterType];

        return currentValue === value;

      });

    }


    /*
      ==========================================
      Update URL
      ==========================================
    */

    function updateURL(
      filterValue,
      page
    ) {

      const url =
        new URL(
          window.location.href
        );


      /*
        Remove old page parameter
      */

      if (page <= 1) {

        url.searchParams.delete(
          "page"
        );

      } else {

        url.searchParams.set(
          "page",
          page
        );

      }


      /*
        Update filter hash
      */

      if (
        filterValue === "all" ||
        !filterValue
      ) {

        url.hash = "";

      } else {

        url.hash =
          encodeURIComponent(
            filterValue
          );

      }


      history.replaceState(
        null,
        "",
        url.pathname +
        (
          url.search
            ? url.search
            : ""
        ) +
        (
          url.hash
            ? url.hash
            : ""
        )
      );

    }


    /*
      ==========================================
      Get filter from URL
      ==========================================
    */

    function getHashFilter() {

      const hash =
        window.location.hash;

      if (
        !hash ||
        hash === "#"
      ) {

        return "all";

      }

      return decodeURIComponent(
        hash.substring(1)
      ).trim();

    }


    /*
      ==========================================
      Get page from URL
      ==========================================
    */

    function getPageFromURL() {

      const url =
        new URL(
          window.location.href
        );

      const page =
        parseInt(
          url.searchParams.get("page"),
          10
        );

      if (
        !page ||
        page < 1
      ) {

        return 1;

      }

      return page;

    }


    /*
      ==========================================
      Render pagination
      ==========================================
    */

    function renderPagination(
      filteredCards
    ) {

      pagination.innerHTML = "";


      const totalPages =
        Math.ceil(
          filteredCards.length /
          postsPerPage
        );


      /*
        No pagination needed
      */

      if (totalPages <= 1) {

        pagination.style.display =
          "none";

        return;

      }


      pagination.style.display =
        "";


      /*
        Previous button
      */

      if (currentPage > 1) {

        const previousButton =
          document.createElement(
            "button"
          );

        previousButton.type =
          "button";

        previousButton.className =
          "project-pagination__button project-pagination__prev";

        previousButton.textContent =
          "Previous";

        previousButton.addEventListener(
          "click",
          () => {

            goToPage(
              currentPage - 1
            );

          }
        );

        pagination.appendChild(
          previousButton
        );

      }


      /*
        Page numbers
      */

      for (
        let page = 1;
        page <= totalPages;
        page++
      ) {

        const pageButton =
          document.createElement(
            "button"
          );

        pageButton.type =
          "button";

        pageButton.className =
          "project-pagination__button";

        pageButton.textContent =
          page;

        pageButton.setAttribute(
          "aria-label",
          `Go to page ${page}`
        );


        if (
          page === currentPage
        ) {

          pageButton.classList.add(
            "active"
          );

          pageButton.setAttribute(
            "aria-current",
            "page"
          );

        }


        pageButton.addEventListener(
          "click",
          () => {

            goToPage(page);

          }
        );


        pagination.appendChild(
          pageButton
        );

      }


      /*
        Next button
      */

      if (
        currentPage < totalPages
      ) {

        const nextButton =
          document.createElement(
            "button"
          );

        nextButton.type =
          "button";

        nextButton.className =
          "project-pagination__button project-pagination__next";

        nextButton.textContent =
          "Next";

        nextButton.addEventListener(
          "click",
          () => {

            goToPage(
              currentPage + 1
            );

          }
        );

        pagination.appendChild(
          nextButton
        );

      }

    }


    /*
      ==========================================
      Render current page
      ==========================================
    */

    function renderPage() {

      const filteredCards =
        getFilteredCards(
          currentFilter
        );


      const totalPages =
        Math.max(
          1,
          Math.ceil(
            filteredCards.length /
            postsPerPage
          )
        );


      /*
        Prevent invalid page
      */

      if (
        currentPage > totalPages
      ) {

        currentPage =
          totalPages;

      }


      /*
        Hide every card first
      */

      cards.forEach((card) => {

        card.style.display =
          "none";

      });


      /*
        Calculate visible range
      */

      const startIndex =
        (
          currentPage - 1
        ) *
        postsPerPage;

      const endIndex =
        startIndex +
        postsPerPage;


      /*
        Show cards for current page
      */

      filteredCards
        .slice(
          startIndex,
          endIndex
        )
        .forEach((card) => {

          card.style.display =
            "";

        });


      /*
        Render pagination
      */

      renderPagination(
        filteredCards
      );

    }


    /*
      ==========================================
      Go to page
      ==========================================
    */

    function goToPage(page) {

      currentPage = page;

      renderPage();

      updateURL(
        currentFilter,
        currentPage
      );


      /*
        Scroll back to project library
        so pagination feels natural.
      */

      const libraryTop =
        library.getBoundingClientRect()
          .top +
        window.pageYOffset -
        100;

      window.scrollTo({
        top: libraryTop,
        behavior: "smooth"
      });

    }


    /*
      ==========================================
      Apply filter
      ==========================================
    */

    function applyFilter(
      value,
      updateUrl = true,
      page = 1
    ) {

      const targetTab =
        Array.from(tabs).find(
          (tab) =>
            tab.dataset.filter === value
        );


      /*
        Invalid filter
        */

      if (!targetTab) {

        value = "all";

        const allTab =
          Array.from(tabs).find(
            (tab) =>
              tab.dataset.filter === "all"
          );

        if (allTab) {

          setActiveTab(
            allTab
          );

        }

      } else {

        setActiveTab(
          targetTab
        );

      }


      currentFilter =
        value;

      currentPage =
        page;


      renderPage();


      if (updateUrl) {

        updateURL(
          currentFilter,
          currentPage
        );

      }

    }


    /*
      ==========================================
      Tab click
      ==========================================
    */

    tabs.forEach((tab) => {

      tab.addEventListener(
        "click",
        () => {

          const value =
            tab.dataset.filter;


          /*
            Every new filter
            starts from page 1
          */

          applyFilter(
            value,
            true,
            1
          );

        }
      );

    });


    /*
      ==========================================
      Initial state
      ==========================================
    */

    const initialFilter =
      getHashFilter();

    const initialPage =
      getPageFromURL();


    applyFilter(
      initialFilter,
      false,
      initialPage
    );


    /*
      ==========================================
      Browser Back / Forward
      ==========================================
    */

    window.addEventListener(
      "hashchange",
      () => {

        const value =
          getHashFilter();

        const page =
          getPageFromURL();

        applyFilter(
          value,
          false,
          page
        );

      }
    );


    window.addEventListener(
      "popstate",
      () => {

        const value =
          getHashFilter();

        const page =
          getPageFromURL();

        applyFilter(
          value,
          false,
          page
        );

      }
    );

  });

});